(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4117],{

/***/ 34117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductCardNewList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(11476);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Favorite.js
var Favorite = __webpack_require__(76324);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(28106);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
// EXTERNAL MODULE: ./src/clients/WishlistClient.js
var WishlistClient = __webpack_require__(56639);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlTable/index.js + 1 modules
var QuantityControlTable = __webpack_require__(60547);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/components/mocules/ProductLimitMessage/index.js
var ProductLimitMessage = __webpack_require__(68556);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/OpenInNew.js
var OpenInNew = __webpack_require__(34276);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/SellerService.js
var SellerService = __webpack_require__(62510);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js
var MonitorUtils = __webpack_require__(31459);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfo/styles.module.css
var styles_module = __webpack_require__(72303);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SellerInfo/index.js

















/*
 Internal Seller:
- Có Hóa Đơn => "MedX"
- Không hóa đơn => Không hiện thị
External Seller:
- Doanh nghiệp => hiện tên doanh nghiệp
- Cá nhân => "Đối tác của thuocsi"
*/ // storeSlugFromUrl lấy slug từ url Gian hàng — vendorInfo.slug có omitempty nên
// có thể vắng. 'https://thuocsi.vn/flagship-store/cty-ta' -> 'cty-ta'.
var storeSlugFromUrl = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return url.split("?")[0].replace(/\/+$/, "").split("/").pop();
};
/**
 * isOtherFlagshipStore: đang ở trang Gian hàng A nhưng SKU lại được trả về dưới
 * danh nghĩa Gian hàng B.
 *
 * Một SKU có thể mang tag của 2 Gian hàng (1 Gian hàng thường + 1 Gian hàng có
 * vendor_store_internal_config). Backend ưu tiên trả Gian hàng CÓ cấu hình, nên
 * trên trang Gian hàng còn lại, tên hiện trên card là của Gian hàng khác — khách
 * không biết ai đang bán SKU này. Trường hợp đó để TRỐNG tên.
 *
 * Chỉ ẩn TÊN. Giá, link, và dữ liệu Gian hàng dùng để thêm vào giỏ giữ nguyên.
 *
 * Không xác định được slug của một trong hai bên -> false (giữ hành vi cũ): thà
 * hiện tên như trước còn hơn ẩn oan.
 */ var isOtherFlagshipStore = function(param) {
    var router = param.router, vendorInfo = param.vendorInfo;
    var ref, ref1;
    if (!(router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.startsWith("/flagship-store/"))) return false;
    var currentStoreSlug = router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.slug;
    var vendorStoreSlug = (vendorInfo === null || vendorInfo === void 0 ? void 0 : vendorInfo.slug) || storeSlugFromUrl((vendorInfo === null || vendorInfo === void 0 ? void 0 : vendorInfo.url) || "");
    if (!currentStoreSlug || !vendorStoreSlug) return false;
    return currentStoreSlug !== vendorStoreSlug;
};
function SellerInfo(param) {
    var _sellerInfo = param.sellerInfo, sellerInfo = _sellerInfo === void 0 ? {} : _sellerInfo, _tags = param.tags, tags = _tags === void 0 ? [] : _tags, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _isWishlist = param.isWishlist, isWishlist = _isWishlist === void 0 ? false : _isWishlist, _isChat = param.isChat, isChat = _isChat === void 0 ? false : _isChat, containerClass = param.containerClass, _isWebView = param.isWebView, isWebView = _isWebView === void 0 ? false : _isWebView, product = param.product;
    var partnerName = "Đối t\xe1c của ".concat(Enums/* BRAND_NAME */.RS);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var router = (0,next_router.useRouter)();
    var ref = (0,SellerService/* getSellerData */.Kz)({
        seller: sellerInfo,
        tags: tags
    }), sellerName = ref.sellerName, fullNameSeller = ref.fullNameSeller, isDisplayStore = ref.isDisplayStore, linkSeller = ref.linkSeller, linkStore = ref.linkStore, _individualNonVatSellerName = ref.individualNonVatSellerName, individualNonVatSellerName = _individualNonVatSellerName === void 0 ? "" : _individualNonVatSellerName, isStore = ref.isStore, statusStore = ref.statusStore;
    // hiển thị với seller là doanh nghiệp ngoài
    // todo: tracking monitor client
    var trackingMonitorClient = function(param) {
        var _url = param.url, url = _url === void 0 ? linkSeller : _url, _reffererUrl = param.reffererUrl, reffererUrl = _reffererUrl === void 0 ? router.asPath : _reffererUrl;
        MonitorUtils/* default.sendPageEvent */.ZP.sendPageEvent({
            url: url,
            reffererUrl: reffererUrl
        });
    };
    // hard code store
    if ((product === null || product === void 0 ? void 0 : product.vendorInfo) && Object.keys(product.vendorInfo).length > 0) {
        var ref1, ref2, ref3, ref4, ref5;
        // Gian hàng trả về khác Gian hàng đang xem -> giữ đúng khung (không xô lệch
        // layout card) nhưng không hiện tên. Xem isOtherFlagshipStore.
        if (isOtherFlagshipStore({
            router: router,
            vendorInfo: product.vendorInfo
        })) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).supplierTitle, containerClass, (0,_define_property/* default */.Z)({}, (styles_module_default()).supplierTitle_mv2, isMobileV2), isChat && (styles_module_default()).m0),
                item: true,
                xs: 12,
                container: true,
                justifyContent: "flex-start",
                direction: "row"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            className: (0,clsx/* default */.Z)((styles_module_default()).supplierTitle, containerClass, (0,_define_property/* default */.Z)({}, (styles_module_default()).supplierTitle_mv2, isMobileV2), isChat && (styles_module_default()).m0),
            item: true,
            xs: 12,
            container: true,
            justifyContent: "flex-start",
            direction: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                disableTouchListener: isMobileV2,
                title: product === null || product === void 0 ? void 0 : (ref1 = product.vendorInfo) === null || ref1 === void 0 ? void 0 : ref1.name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    className: isWishlist ? (styles_module_default()).supplier_title_v2 : (styles_module_default()).name,
                    item: true,
                    xs: 12,
                    container: true,
                    justifyContent: "flex-start",
                    direction: "row",
                    children: [
                        !isProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Cung cấp bởi: "
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            width: "14",
                            height: "16",
                            src: Icons/* COLOR_STORE */.bV2,
                            alt: product === null || product === void 0 ? void 0 : (ref2 = product.vendorInfo) === null || ref2 === void 0 ? void 0 : ref2.name,
                            className: (styles_module_default()).image_logo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, isChat && (styles_module_default()).sellerProduct),
                                stopProp: true,
                                style: {
                                    fontSize: !isChat && 12
                                },
                                children: product === null || product === void 0 ? void 0 : (ref3 = product.vendorInfo) === null || ref3 === void 0 ? void 0 : ref3.name
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                target: "_blank",
                                className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, isChat && (styles_module_default()).sellerProduct),
                                stopProp: true,
                                style: {
                                    fontSize: !isChat && 12
                                },
                                href: product === null || product === void 0 ? void 0 : (ref4 = product.vendorInfo) === null || ref4 === void 0 ? void 0 : ref4.url,
                                onClick: function() {
                                    trackingMonitorClient({});
                                },
                                children: product === null || product === void 0 ? void 0 : (ref5 = product.vendorInfo) === null || ref5 === void 0 ? void 0 : ref5.name
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        className: (0,clsx/* default */.Z)((styles_module_default()).supplierTitle, (0,_define_property/* default */.Z)({}, (styles_module_default()).supplierTitle_mv2, isMobileV2), isChat && (styles_module_default()).m0),
        item: true,
        xs: 12,
        container: true,
        justifyContent: "flex-start",
        direction: "row",
        children: (individualNonVatSellerName || sellerName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            disableTouchListener: isMobileV2,
            title: fullNameSeller,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                className: isWishlist ? (styles_module_default()).supplier_title_v2 : (styles_module_default()).name,
                item: true,
                xs: 12,
                container: true,
                justifyContent: "flex-start",
                direction: "row",
                children: [
                    !isProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Cung cấp bởi: "
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        width: "14",
                        height: "16",
                        src: Icons/* COLOR_STORE */.bV2,
                        alt: sellerName,
                        className: (styles_module_default()).image_logo
                    }),
                    statusStore === "ACTIVE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            stopProp: true,
                            className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, isChat && (styles_module_default()).sellerProduct),
                            children: [
                                individualNonVatSellerName || sellerName,
                                !isProductCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                    title: "Xem cửa h\xe0ng",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInNew/* default */.Z, {
                                        style: {
                                            color: "#676F77",
                                            paddingTop: "10px",
                                            marginBottom: "-3px"
                                        }
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                            stopProp: true,
                            target: "_blank",
                            className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, isChat && (styles_module_default()).sellerProduct),
                            href: isStore ? linkStore : linkSeller,
                            onClick: function() {
                                trackingMonitorClient({
                                    url: isStore ? linkStore : linkSeller
                                });
                            },
                            children: [
                                individualNonVatSellerName || sellerName,
                                !isProductCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                    title: "Xem cửa h\xe0ng",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInNew/* default */.Z, {
                                        style: {
                                            color: "#676F77",
                                            paddingTop: "10px",
                                            marginBottom: "-3px"
                                        }
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isDisplayStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                stopProp: true,
                                className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, isChat && (styles_module_default()).sellerProduct),
                                children: individualNonVatSellerName || sellerName
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                stopProp: true,
                                target: "_blank",
                                className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, isChat && (styles_module_default()).sellerProduct),
                                href: linkSeller,
                                onClick: function() {
                                    trackingMonitorClient({});
                                },
                                children: individualNonVatSellerName || sellerName
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                stopProp: true,
                                className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, sellerName === partnerName && (styles_module_default()).text_tf_none, isChat && (styles_module_default()).sellerProduct)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                stopProp: true,
                                target: "_blank",
                                className: (0,clsx/* default */.Z)((styles_module_default()).link, (0,_define_property/* default */.Z)({}, (styles_module_default()).link_mv2, isMobileV2), isWishlist && (styles_module_default()).supplier_title_v2, sellerName === partnerName && (styles_module_default()).text_tf_none, isChat && (styles_module_default()).sellerProduct),
                                href: linkSeller,
                                onClick: function() {
                                    trackingMonitorClient({});
                                },
                                children: individualNonVatSellerName || sellerName
                            })
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var mocules_SellerInfo = (/*#__PURE__*/(0,react.memo)(SellerInfo));

// EXTERNAL MODULE: ./src/constants/Enums/http.js
var http = __webpack_require__(53208);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/constants/SVG/index.ts
var SVG = __webpack_require__(69448);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./src/hooks/useOnceInViewport.js
var useOnceInViewport = __webpack_require__(29720);
// EXTERNAL MODULE: ./src/hooks/useTrackingMonitorHighMargin.ts
var useTrackingMonitorHighMargin = __webpack_require__(30086);
// EXTERNAL MODULE: ./src/hooks/useTrackingMonitor.js
var useTrackingMonitor = __webpack_require__(64875);
// EXTERNAL MODULE: ./src/hooks/useTrackingMonitorSubstituteProduct.ts
var useTrackingMonitorSubstituteProduct = __webpack_require__(9358);
// EXTERNAL MODULE: ./src/utils/TrackingHelpers.js
var TrackingHelpers = __webpack_require__(2288);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/services/convertNewAPIProduct.js
var convertNewAPIProduct = __webpack_require__(20402);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/calculateTimeLeftV2.js
var calculateTimeLeftV2 = __webpack_require__(92147);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(46203);
// EXTERNAL MODULE: ./src/utils/ProductLabelUtils.ts
var ProductLabelUtils = __webpack_require__(21038);
// EXTERNAL MODULE: ./src/utils/ImageUtils.tsx
var ImageUtils = __webpack_require__(81989);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
// EXTERNAL MODULE: ./src/zustand-lib/useProductList.ts
var useProductList = __webpack_require__(52261);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js
var useSellers = __webpack_require__(84003);
// EXTERNAL MODULE: ./src/components-v2/mocules/BorderLinearProgress/index.js
var BorderLinearProgress = __webpack_require__(22731);
// EXTERNAL MODULE: ./src/components-v2/mocules/CountdownNewV2/index.js
var CountdownNewV2 = __webpack_require__(67154);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./src/components-v2/ui/ConsultSpecialProductBtn/index.js + 4 modules
var ConsultSpecialProductBtn = __webpack_require__(40420);
// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/index.js
var RemoveProductModal = __webpack_require__(64325);
// EXTERNAL MODULE: ./src/hooks/useProductConsultation.js
var useProductConsultation = __webpack_require__(48699);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartQuantityControl/useCartQuantityControl.ts
var useCartQuantityControl = __webpack_require__(91271);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlCart/styles.module.css
var QuantityControlCart_styles_module = __webpack_require__(29767);
var QuantityControlCart_styles_module_default = /*#__PURE__*/__webpack_require__.n(QuantityControlCart_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/QuantityControlCart/index.js













var CartIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (QuantityControlCart_styles_module_default()).inputVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z",
                    fill: "#999999"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z",
                    fill: "#999999"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z",
                    fill: "#999999"
                })
            ]
        })
    });
};
var NewIconMinus = function(param) {
    var handleDecrease = param.handleDecrease, currentValue = param.currentValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleDecrease,
        className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()).minusContainerNew, "qty-control-cart-minus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "28",
            height: "28",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12H17",
                stroke: currentValue === 0 ? "#999999" : "#005c29",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        })
    });
};
var IconMinus = function(param) {
    var handleDecrease = param.handleDecrease;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleDecrease,
        className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()).minusContainer, "qty-control-cart-minus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (QuantityControlCart_styles_module_default()).minus
        })
    });
};
var NewIconAdd = function(param) {
    var handleIncrease = param.handleIncrease, currentValue = param.currentValue, maxQuantityConsumed = param.maxQuantityConsumed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIncrease,
        className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()).addContainerNew, "qty-control-cart-plus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "28",
            height: "28",
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 17V7",
                    stroke: currentValue >= maxQuantityConsumed ? "#999999" : "#005c29",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7 12L17 12",
                    stroke: currentValue >= maxQuantityConsumed ? "#999999" : "#005c29",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        })
    });
};
var IconAdd = function(param) {
    var handleIncrease = param.handleIncrease, currentValue = param.currentValue, maxQuantityConsumed = param.maxQuantityConsumed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIncrease,
        className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()).addContainer, currentValue >= maxQuantityConsumed && (QuantityControlCart_styles_module_default()).disabled, "qty-control-cart-plus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (QuantityControlCart_styles_module_default()).addIcon
        })
    });
};
var QuantityControlCart = function(param) {
    var product = param.product, className = param.className, isBuy = param.isBuy, newCard = param.newCard, mode = param.mode;
    var ref, ref1, ref2;
    var refValue = (0,react.useRef)(null);
    var ref3 = (0,useCartQuantityControl/* default */.Z)({
        id: product === null || product === void 0 ? void 0 : product.productId,
        name: product === null || product === void 0 ? void 0 : product.name,
        price: product === null || product === void 0 ? void 0 : product.displayPrice,
        sellerCode: product === null || product === void 0 ? void 0 : product.sellerCode,
        sellerId: product === null || product === void 0 ? void 0 : (ref = product.sellerInfo) === null || ref === void 0 ? void 0 : ref.sellerID,
        quantityInCart: product.quantity || 0,
        skuCode: product === null || product === void 0 ? void 0 : product.sku,
        type: product === null || product === void 0 ? void 0 : product.productSkuType,
        slug: product === null || product === void 0 ? void 0 : product.slug,
        maxQuantity: product.maxQuantity,
        recommendSKUs: product.recommendSKUs,
        blockCode: product.blockCode,
        mode: mode
    }, refValue), handleIncrease = ref3.handleIncrease, handleBlurInput = ref3.handleBlurInput, handleChangeInput = ref3.handleChangeInput, handleDecrease = ref3.handleDecrease, confirmRemove = ref3.confirmRemove, closeModal = ref3.closeModal, isShowModalRemove = ref3.isShowModalRemove, currentValue = ref3.currentValue;
    var shouldShowConsultButton = (0,useProductConsultation/* useProductConsultation */.O)().shouldShowConsultButton;
    var handleCancel = function(e) {
        e.stopPropagation();
        closeModal();
    };
    var handleRemove = function() {
        confirmRemove();
    };
    if (shouldShowConsultButton(product)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultSpecialProductBtn/* default */.Z, {
            className: "qty-control-cart-consult-btn",
            product: product,
            variant: ConsultSpecialProductBtn/* VARIANT_LIST.LIST */.C.LIST
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (QuantityControlCart_styles_module_default()).maxWidth,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()).container, isBuy && (QuantityControlCart_styles_module_default()).isBuy, className && className, "qty-control-cart-wrapper"),
            children: [
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIconMinus, {
                    currentValue: currentValue,
                    handleDecrease: handleDecrease
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMinus, {
                    handleDecrease: handleDecrease
                }),
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()).groupInput, "qty-control-cart-input-group"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (QuantityControlCart_styles_module_default()).cartIconContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (QuantityControlCart_styles_module_default()) === null || (QuantityControlCart_styles_module_default()) === void 0 ? void 0 : (QuantityControlCart_styles_module_default()).currentValue,
                                    children: currentValue
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            className: (0,clsx/* default */.Z)((QuantityControlCart_styles_module_default()) === null || (QuantityControlCart_styles_module_default()) === void 0 ? void 0 : (QuantityControlCart_styles_module_default()).newCardInput, "qty-control-cart-input"),
                            inputRef: refValue,
                            onBlur: handleBlurInput,
                            onChange: handleChangeInput,
                            type: "number",
                            disableUnderline: true
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    className: "qty-control-cart-input",
                    inputRef: refValue,
                    onBlur: handleBlurInput,
                    onChange: handleChangeInput,
                    type: "number",
                    disableUnderline: true
                }),
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIconAdd, {
                    handleIncrease: handleIncrease,
                    currentValue: currentValue,
                    maxQuantityConsumed: product === null || product === void 0 ? void 0 : (ref1 = product.consumedMaxQuantity) === null || ref1 === void 0 ? void 0 : ref1.maxQuantityConsumed
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAdd, {
                    handleIncrease: handleIncrease,
                    currentValue: currentValue,
                    maxQuantityConsumed: product === null || product === void 0 ? void 0 : (ref2 = product.consumedMaxQuantity) === null || ref2 === void 0 ? void 0 : ref2.maxQuantityConsumed
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                    product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                        name: product === null || product === void 0 ? void 0 : product.productName,
                        defaultImage: product === null || product === void 0 ? void 0 : product.imageUrl,
                        displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)((0,helper/* encryptedData */.YU)(product === null || product === void 0 ? void 0 : product.priceEncrypted))
                    }),
                    visible: isShowModalRemove,
                    onClose: handleCancel,
                    onRemove: handleRemove
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_QuantityControlCart = (QuantityControlCart);

// EXTERNAL MODULE: ./src/components-v2/mocules/ProductCardNewList/styles.module.css
var ProductCardNewList_styles_module = __webpack_require__(80966);
var ProductCardNewList_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardNewList_styles_module);
// EXTERNAL MODULE: ./src/hooks/useConfigHangDiem.ts
var useConfigHangDiem = __webpack_require__(53069);
// EXTERNAL MODULE: ./src/components-v2/atoms/ReplaceHangDiem/index.tsx
var ReplaceHangDiem = __webpack_require__(46542);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ProductCardNewList/index.js























































var LightTooltip = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "#A2A0A0"
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#A2A0A0",
        color: "#fff",
        fontSize: 12,
        top: "0px"
    }), _obj;
});
function ProductTagNew(param) {
    var data = param.data;
    return (data === null || data === void 0 ? void 0 : data.preIconSvg) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
        href: data === null || data === void 0 ? void 0 : data.link,
        className: (ProductCardNewList_styles_module_default()).tagContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
            className: (ProductCardNewList_styles_module_default()).image,
            height: 30,
            width: 60,
            objectFit: "contain",
            fallbackSrc: (0,ImageUtils/* getLinkProxyFile */.GD)(data === null || data === void 0 ? void 0 : data.preIconSvg),
            src: (0,ImageUtils/* getLinkProxyFile */.GD)(data === null || data === void 0 ? void 0 : data.preIconSvg),
            alt: "img"
        })
    }) : null;
}
function ProductCardNewList(param) {
    var product = param.product, className = param.className, isTourGuide = param.isTourGuide, _showOriginalPrice = param.showOriginalPrice, showOriginalPrice = _showOriginalPrice === void 0 ? false : _showOriginalPrice, _isCartPage = param.isCartPage, isCartPage = _isCartPage === void 0 ? false : _isCartPage, _isSubstitude = param.isSubstitude, isSubstitude = _isSubstitude === void 0 ? false : _isSubstitude, _skuSubstitute = param.skuSubstitute, skuSubstitute = _skuSubstitute === void 0 ? "" : _skuSubstitute, mode = param.mode;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var router = (0,next_router.useRouter)();
    var user = (0,Auth/* useAuth */.aC)().user;
    var curTime = new Date();
    // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
    var medicineTypeLabels = (0,ProductLabelUtils/* getMedicineTypeLabels */.RG)(product);
    var ref18 = (0,react.useState)(false), isWish = ref18[0], setIsWish = ref18[1];
    (0,react.useEffect)(function() {
        setIsWish(product.isWishList);
    }, [
        product.isWishList
    ]);
    var ref19 = (0,react.useState)(), dealEndCampaign = ref19[0], setDealEndCampaign = ref19[1];
    var ref20 = (0,react.useState)(), memoizedTimeRemaining = ref20[0], setMemoizedTimeRemaining = ref20[1];
    var percentLine = Math.round(((ref = product.campaign) === null || ref === void 0 ? void 0 : ref.totalSoldQuantity) / ((ref1 = product.campaign) === null || ref1 === void 0 ? void 0 : ref1.totalQuantity) * 100);
    var percentLineDeal = Math.round(((ref2 = product.deal) === null || ref2 === void 0 ? void 0 : ref2.totalCurrentQuantity) / ((ref3 = product.deal) === null || ref3 === void 0 ? void 0 : ref3.totalDealQuantity) * 100);
    var totalSold = ((ref4 = product.campaign) === null || ref4 === void 0 ? void 0 : ref4.totalSoldQuantity) || ((ref5 = product.deal) === null || ref5 === void 0 ? void 0 : ref5.totalCurrentQuantity);
    var nearExpiration = product === null || product === void 0 ? void 0 : (ref6 = product.skuTags) === null || ref6 === void 0 ? void 0 : ref6.find(function(x) {
        return (x === null || x === void 0 ? void 0 : x.code) === "NEAR_EXPIRATION";
    });
    var firstSubstituteSkuRef = (0,useProductList/* default */.Z)().firstSubstituteSkuRef;
    var ref21 = (0,useConfigHangDiem/* useConfigHangDiem */.x)({
        vendorInfoSellerCode: product === null || product === void 0 ? void 0 : (ref7 = product.vendorInfo) === null || ref7 === void 0 ? void 0 : ref7.sellerCode
    }), isHangDiem = ref21.isHangDiem, iconHangDiem = ref21.iconHangDiem;
    var trackingRef = (0,react.useRef)(null);
    (0,useTrackingMonitor/* default */.Z)(trackingRef, product);
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var sendEventCollector = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.sendEventCollector;
    });
    function handleTrackingViewDetail() {
        return _handleTrackingViewDetail.apply(this, arguments);
    }
    function _handleTrackingViewDetail() {
        _handleTrackingViewDetail = (0,_async_to_generator/* default */.Z)(function() {
            var sellerInfo, _tmp, _tmp1, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            getSellerByCode((_tmp.code = product === null || product === void 0 ? void 0 : product.sellerCode, _tmp.tags = product.tags, _tmp))
                        ];
                    case 1:
                        sellerInfo = _state.sent();
                        _tmp1 = {};
                        gtag/* default.viewItemInPage */.ZP.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                            sellerInfo: sellerInfo
                        }), _tmp1.path = router.pathname, _tmp1));
                        _tmp2 = {};
                        _tmp3 = {};
                        sendEventCollector(MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(MonitorUtils/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfo = sellerInfo, _tmp3)), router.pathname, true));
                        handleHighMarginClickDetail();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleTrackingViewDetail.apply(this, arguments);
    }
    var ref22 = (0,useTrackingMonitorSubstituteProduct/* default */.Z)(), trackingMonitorSubstituteAddToCart = ref22.trackingMonitorSubstituteAddToCart, trackingMonitorSubstituteClickDetail = ref22.trackingMonitorSubstituteClickDetail, trackingMonitorSubstituteMainSKUImpression = ref22.trackingMonitorSubstituteMainSKUImpression;
    var ref23 = (0,useTrackingMonitorHighMargin/* default */.Z)(), trackingHighMarginImpression = ref23.trackingHighMarginImpression, trackingHighMarginClickDetail = ref23.trackingHighMarginClickDetail, trackingHighMarginAddToCart = ref23.trackingHighMarginAddToCart;
    var ref24 = router.query || {}, sellerIdMainSKU = ref24.sellerIdMainSKU, productIdMainSKU = ref24.productIdMainSKU, mainSKU = ref24.mainSKU, mainType = ref24.mainType;
    var linkHref = isSubstitude ? "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat(product.slug || "", "?isSKUReplace=true&sellerIdMainSKU=").concat(sellerIdMainSKU, "&productIdMainSKU=").concat(productIdMainSKU, "&mainSKU=").concat(mainSKU, "&mainType=").concat(mainType) : "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat(product.slug || "");
    var appSetting = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.appSetting;
    });
    var errorMessageProduct = (0,convertNewAPIProduct/* getSKUErrorMessage */.V9)(product, appSetting);
    var revertDisplayFormat = function(price) {
        if ((price === null || price === void 0 ? void 0 : price.length) > 11) {
            return (price === null || price === void 0 ? void 0 : price.substring(0, 8)) + "..";
        }
        return price;
    };
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var convertEndDay = product.productType === "MEGA_DAY" ? (ref = product.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.campaign) === null || ref1 === void 0 ? void 0 : ref1.endTime : (ref4 = (ref2 = product.campaign) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.flashSaleTime) === null || ref3 === void 0 ? void 0 : ref3.find(function(item) {
            return new Date(item.startTime) < curTime && new Date(item.endTime) > curTime;
        })) === null || ref4 === void 0 ? void 0 : ref4.endTime;
        setDealEndCampaign(convertEndDay);
        setMemoizedTimeRemaining((0,calculateTimeLeftV2/* default */.Z)(convertEndDay || ((ref5 = product.deal) === null || ref5 === void 0 ? void 0 : ref5.endTime)));
    }, []);
    var handleDeleteProductWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,WishlistClient/* deleteItemWishlist */.xb)(product === null || product === void 0 ? void 0 : product.sku)
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,Clients/* isValidWithoutData */.Wk)(res)) {
                            setIsWish(function() {
                                return false;
                            });
                            return [
                                2,
                                NotifyUtils/* default.success */.Z.success("Đ\xe3 x\xf3a ".concat(product === null || product === void 0 ? void 0 : product.name, " khỏi danh s\xe1ch quan t\xe2m"))
                            ];
                        }
                        return [
                            2,
                            NotifyUtils/* default.error */.Z.error("X\xf3a sản phẩm ".concat(product === null || product === void 0 ? void 0 : product.name, " khỏi danh s\xe1ch quan t\xe2m thất bại"))
                        ];
                }
            });
        });
        return function handleDeleteProductWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdateWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,WishlistClient/* updateWishlist */.jV)(product === null || product === void 0 ? void 0 : product.sku)
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,Clients/* isValid */.JY)(res) || (res === null || res === void 0 ? void 0 : res.status) === http/* HTTP_STATUS.Existed */.M.Existed) {
                            setIsWish(function() {
                                return true;
                            });
                            return [
                                2,
                                NotifyUtils/* default.success */.Z.success("Đ\xe3 th\xeam ".concat(product === null || product === void 0 ? void 0 : product.name, " v\xe0o danh s\xe1ch quan t\xe2m"))
                            ];
                        }
                        return [
                            2,
                            NotifyUtils/* default.error */.Z.error("Th\xeam ".concat(product === null || product === void 0 ? void 0 : product.name, " v\xe0o danh s\xe1ch sản phẩm quan t\xe2m thất bại"))
                        ];
                }
            });
        });
        return function handleUpdateWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickWhistList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (isWish) {
                    handleDeleteProductWishlist(product);
                } else {
                    handleUpdateWishlist(product);
                }
                return [
                    2
                ];
            });
        });
        return function handleClickWhistList() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasError = errorMessageProduct || !product.salePrice || product.status === "STOP_SELLING" || product.salePrice === 0;
    var conditionRenderTag = function(listTag) {
        if (listTag && (listTag === null || listTag === void 0 ? void 0 : listTag.length) > 3) {
            return listTag === null || listTag === void 0 ? void 0 : listTag.filter(function(x) {
                return (x === null || x === void 0 ? void 0 : x.code) !== "NEAR_EXPIRATION";
            }).slice(0, 3);
        }
        return listTag === null || listTag === void 0 ? void 0 : listTag.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.code) !== "NEAR_EXPIRATION";
        });
    };
    var renderQuantityInput = function() {
        var ref, ref1;
        var handleClickSubstituteAddToCart = function() {
            if (isSubstitude) {
                gtag/* default.substituteClickAddToCart */.ZP.substituteClickAddToCart({
                    screen: (0,gtag/* mapPathToCategory */.GH)(router.pathname),
                    customerId: user === null || user === void 0 ? void 0 : user.customerID,
                    sku: product.sku,
                    productId: product.productId,
                    sellerId: product.sellerInfo.sellerID,
                    resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                    mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)(mainType)
                });
                trackingMonitorSubstituteAddToCart({
                    sku: product.sku,
                    sellerId: product.sellerInfo.sellerID,
                    sellerCode: product.seller.code,
                    productId: product.productId,
                    type: (product === null || product === void 0 ? void 0 : product.errorCode) || "Instock",
                    pathname: router.pathname,
                    resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                    sellerIdMainSKU: sellerIdMainSKU || "",
                    productIdMainSKU: productIdMainSKU || "",
                    mainSKU: mainSKU || "",
                    mainType: mainType || ""
                });
            }
        };
        var isMaxBuy = (product === null || product === void 0 ? void 0 : (ref = product.consumedMaxQuantity) === null || ref === void 0 ? void 0 : ref.maxQuantityConsumed) === 0 && (product === null || product === void 0 ? void 0 : (ref1 = product.consumedMaxQuantity) === null || ref1 === void 0 ? void 0 : ref1.maxQuantityType) === "PER_DAY";
        if (isMaxBuy) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        if (isCartPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_QuantityControlCart, {
                className: (ProductCardNewList_styles_module_default()).quantityControlContainer,
                product: product,
                newCard: true,
                mode: mode
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlTable/* default */.Z, {
            className: (ProductCardNewList_styles_module_default()).quantityControlContainer,
            product: product,
            newCard: true,
            onChange: function() {
                handleClickSubstituteAddToCart();
                handleHighMarginAddToCart();
            },
            onAdd: function() {
                handleClickSubstituteAddToCart();
                handleHighMarginAddToCart();
            }
        });
    };
    var conditionRenderCountdown = function() {
        if (showOriginalPrice) {
            return true;
        }
        // make sure time countdown is 96 hours
        // days < 4 => 72h + 24h => maximum 96h
        if ((memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.days) < 4) {
            return false;
        }
        return true;
    };
    var handleClickSubstitute = function() {
        // TODO: Click to substitute product
        if (isSubstitude) {
            gtag/* default.substituteClickDetail */.ZP.substituteClickDetail({
                customerId: user === null || user === void 0 ? void 0 : user.customerID,
                screen: (0,gtag/* mapPathToCategory */.GH)(router.pathname),
                sku: product.sku,
                productId: product.productId,
                sellerCode: product.seller.code,
                sellerId: product.sellerInfo.sellerID,
                resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)(mainType)
            });
            trackingMonitorSubstituteClickDetail({
                sku: product.sku,
                sellerCode: product.seller.code,
                sellerId: product.sellerInfo.sellerID,
                productId: product.productId,
                type: (product === null || product === void 0 ? void 0 : product.errorCode) || "Instock",
                pathname: router.pathname,
                resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                sellerIdMainSKU: sellerIdMainSKU || "",
                productIdMainSKU: productIdMainSKU || "",
                mainSKU: mainSKU || "",
                mainType: mainType || ""
            });
        }
    };
    // Impression 50% viewport (spec MKT), thay cho onMouseEnter trước đây:
    // - card SP thay thế (isSubstitude): event "Search result having substitute product impression"
    // - card SKU gốc có hàng thay thế (skuReplace): event "Oos/suspended SKU impression"
    var oosImpressionRef = (0,useOnceInViewport/* default */.Z)(function() {
        var ref, ref1, ref2;
        // Event "Search result having high margin product impression" (spec MKT)
        if (product === null || product === void 0 ? void 0 : product.isHighProfit) {
            var ref3, ref4, ref5, ref6;
            gtag/* default.highMarginImpression */.ZP.highMarginImpression({
                customerId: user === null || user === void 0 ? void 0 : user.customerID,
                screen: (0,gtag/* mapPathToCategory */.GH)(router.pathname),
                resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                sku: product.sku,
                sellerId: (ref3 = product.sellerInfo) === null || ref3 === void 0 ? void 0 : ref3.sellerID,
                productId: product.productId
            });
            trackingHighMarginImpression({
                sku: product.sku,
                sellerId: ((ref4 = product.sellerInfo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sellerID) === null || ref5 === void 0 ? void 0 : ref5.toString()) || "",
                productId: ((ref6 = product.productId) === null || ref6 === void 0 ? void 0 : ref6.toString()) || "",
                pathname: router.pathname,
                resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router)
            });
        }
        if (isSubstitude) {
            var ref7, ref8, ref9;
            gtag/* default.substituteSearchResult */.ZP.substituteSearchResult({
                screen: (0,gtag/* mapPathToCategory */.GH)(router.pathname),
                customerId: user === null || user === void 0 ? void 0 : user.customerID,
                resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)(mainType),
                sku: product.sku,
                sellerId: (ref7 = product.sellerInfo) === null || ref7 === void 0 ? void 0 : ref7.sellerID,
                productId: product.productId
            });
            trackingMonitorSubstituteMainSKUImpression({
                sku: product.sku,
                sellerCode: (ref8 = product.seller) === null || ref8 === void 0 ? void 0 : ref8.code,
                sellerId: (ref9 = product.sellerInfo) === null || ref9 === void 0 ? void 0 : ref9.sellerID,
                productId: product.productId,
                type: (product === null || product === void 0 ? void 0 : product.errorCode) || "Instock",
                pathname: router.pathname,
                resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
                sellerIdMainSKU: sellerIdMainSKU || "",
                productIdMainSKU: productIdMainSKU || "",
                mainSKU: mainSKU || "",
                mainType: mainType || ""
            });
            return;
        }
        if (!(((ref = product.skuReplace) === null || ref === void 0 ? void 0 : ref.length) > 0)) return;
        gtag/* default.substituteHoverProductCard */.ZP.substituteHoverProductCard({
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            sku: product.sku,
            productId: product.productId,
            sellerCode: (ref1 = product.seller) === null || ref1 === void 0 ? void 0 : ref1.code,
            resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router)
        });
        trackingMonitorSubstituteMainSKUImpression({
            sku: product.sku,
            sellerCode: (ref2 = product.seller) === null || ref2 === void 0 ? void 0 : ref2.code,
            productId: product.productId,
            type: (product === null || product === void 0 ? void 0 : product.errorCode) || "Instock",
            pathname: router.pathname,
            resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
            sellerIdMainSKU: sellerIdMainSKU || "",
            productIdMainSKU: productIdMainSKU || "",
            mainSKU: mainSKU || "",
            mainType: mainType || ""
        });
    }, 0.5, isSubstitude || !!(product === null || product === void 0 ? void 0 : product.isHighProfit) || (product === null || product === void 0 ? void 0 : (ref8 = product.skuReplace) === null || ref8 === void 0 ? void 0 : ref8.length) > 0);
    var handleHighMarginClickDetail = function() {
        var ref, ref1, ref2, ref3;
        if (!(product === null || product === void 0 ? void 0 : product.isHighProfit)) return;
        gtag/* default.highMarginClickDetail */.ZP.highMarginClickDetail({
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            screen: (0,gtag/* mapPathToCategory */.GH)(router.pathname),
            resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
            sku: product.sku,
            sellerId: (ref = product.sellerInfo) === null || ref === void 0 ? void 0 : ref.sellerID,
            productId: product.productId
        });
        trackingHighMarginClickDetail({
            sku: product.sku,
            sellerId: ((ref1 = product.sellerInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sellerID) === null || ref2 === void 0 ? void 0 : ref2.toString()) || "",
            productId: ((ref3 = product.productId) === null || ref3 === void 0 ? void 0 : ref3.toString()) || "",
            pathname: router.pathname,
            resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router)
        });
    };
    var handleHighMarginAddToCart = function() {
        var ref, ref1, ref2, ref3;
        if (!(product === null || product === void 0 ? void 0 : product.isHighProfit)) return;
        gtag/* default.highMarginAddToCart */.ZP.highMarginAddToCart({
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            screen: (0,gtag/* mapPathToCategory */.GH)(router.pathname),
            resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router),
            sku: product.sku,
            sellerId: (ref = product.sellerInfo) === null || ref === void 0 ? void 0 : ref.sellerID,
            productId: product.productId
        });
        trackingHighMarginAddToCart({
            sku: product.sku,
            sellerId: ((ref1 = product.sellerInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sellerID) === null || ref2 === void 0 ? void 0 : ref2.toString()) || "",
            productId: ((ref3 = product.productId) === null || ref3 === void 0 ? void 0 : ref3.toString()) || "",
            pathname: router.pathname,
            resultPage: (0,TrackingHelpers/* getResultPage */.Sq)(router)
        });
    };
    var ref25;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)((ProductCardNewList_styles_module_default()).container, className && className, "card-new-list"),
        id: product.sku,
        onClick: handleClickSubstitute,
        ref: (0,TrackingHelpers/* mergeRefs */.lq)(skuSubstitute === product.sku ? firstSubstituteSkuRef : trackingRef, oosImpressionRef),
        children: [
            product.discountPercent && !isSubstitude ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductCardNewList_styles_module_default()).promo,
                children: [
                    " -",
                    product.discountPercent,
                    "%"
                ]
            }) : null,
            product.isContractPrice && !isSubstitude ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductCardNewList_styles_module_default()).contract,
                children: " Gi\xe1 Hợp Đồng"
            }) : null,
            nearExpiration && !isSubstitude ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: nearExpiration === null || nearExpiration === void 0 ? void 0 : nearExpiration.textColor,
                    backgroundColor: nearExpiration === null || nearExpiration === void 0 ? void 0 : nearExpiration.backgroundColor
                },
                className: (ProductCardNewList_styles_module_default()).nearExpiration,
                children: nearExpiration === null || nearExpiration === void 0 ? void 0 : nearExpiration.name
            }) : null,
            !!isSubstitude && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (ProductCardNewList_styles_module_default()).replaceSkuTag,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Images/* SUBSTITUDE_REPLACE_ICON */.m8e,
                        width: 16,
                        height: 16,
                        alt: "replace icon"
                    }),
                    " Sản phẩm thay thế"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductCardNewList_styles_module_default()).tooltipRight,
                onClick: handleClickWhistList,
                role: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                    title: isWish ? "Bỏ đ\xe1nh dấu sản phẩm" : "Đ\xe1nh dấu sản phẩm quan t\xe2m",
                    arrow: true,
                    placement: "top",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardNewList_styles_module_default()) === null || (ProductCardNewList_styles_module_default()) === void 0 ? void 0 : (ProductCardNewList_styles_module_default()).customButton,
                        children: isWish ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                            style: {
                                fontSize: 24,
                                color: "var(--primary-color)"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {
                            className: (ProductCardNewList_styles_module_default()).icon,
                            style: {
                                fontSize: 24,
                                color: "#00000033"
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductCardNewList_styles_module_default()).topContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        href: linkHref,
                        className: (ProductCardNewList_styles_module_default()).stylesImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                            className: (ProductCardNewList_styles_module_default()).image,
                            size: "medium",
                            height: 160,
                            width: 160,
                            objectFit: "contain",
                            src: product.defaultImage,
                            alt: "img",
                            onClick: handleTrackingViewDetail
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardNewList_styles_module_default()).listTag,
                        children: (ref9 = conditionRenderTag(product === null || product === void 0 ? void 0 : product.skuTags)) === null || ref9 === void 0 ? void 0 : ref9.map(function(x) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductTagNew, {
                                data: x
                            }, x === null || x === void 0 ? void 0 : x.code);
                        })
                    }),
                    isTourGuide ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "list__tag_guide",
                        className: (0,clsx/* default */.Z)((ProductCardNewList_styles_module_default()).listTagGuide, product.productType === "MEGA_DAY" && (ProductCardNewList_styles_module_default()).listTagGuideMega),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductCardNewList_styles_module_default()).listTag,
                            children: (ref10 = conditionRenderTag(product === null || product === void 0 ? void 0 : product.skuTags)) === null || ref10 === void 0 ? void 0 : ref10.map(function(x) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductTagNew, {
                                    data: x
                                }, x === null || x === void 0 ? void 0 : x.code);
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardNewList_styles_module_default()).listTag,
                        children: (ref11 = conditionRenderTag(product === null || product === void 0 ? void 0 : product.skuTags)) === null || ref11 === void 0 ? void 0 : ref11.map(function(x) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductTagNew, {
                                data: x
                            }, x === null || x === void 0 ? void 0 : x.code);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductCardNewList_styles_module_default()).underContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardNewList_styles_module_default()).priceContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardNewList_styles_module_default()).price,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                    displayPriceFormated: product.displayPriceFormated || 0,
                                    size: "mdn"
                                })
                            }),
                            product.discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    conditionRenderCountdown() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProductCardNewList_styles_module_default()).pricePromo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                            displayPriceFormated: (ref25 = revertDisplayFormat(product.salePriceFormated)) !== null && ref25 !== void 0 ? ref25 : 0,
                                            size: "smn",
                                            fillPath: "#333333",
                                            line: true
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx/* default */.Z)((ProductCardNewList_styles_module_default()).dateExpired),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownNewV2/* default */.Z, {
                                            targetDate: dealEndCampaign || ((ref12 = product.deal) === null || ref12 === void 0 ? void 0 : ref12.endTime),
                                            hasMoreText: true
                                        })
                                    }),
                                    isSubstitude && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                        className: (ProductCardNewList_styles_module_default()).cardChip,
                                        label: "-".concat(product.discountPercent, "%"),
                                        size: "small"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardNewList_styles_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: linkHref,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: (ProductCardNewList_styles_module_default()).titleWrapper,
                                    onClick: handleTrackingViewDetail,
                                    children: [
                                        (ref13 = product.skuLabels) === null || ref13 === void 0 ? void 0 : ref13.map(function(label) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                className: (ProductCardNewList_styles_module_default()).labelImage,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx/* default */.Z)(!isHangDiem ? (ProductCardNewList_styles_module_default()).labelImage : (ProductCardNewList_styles_module_default()).hangDiemLabelImage),
                                                    children: isHangDiem && label.code === "2ABC" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplaceHangDiem/* default */.Z, {
                                                        iconHangDiem: iconHangDiem,
                                                        type: "old_product"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                        width: label.code === "2ABC" ? 63 : 25,
                                                        height: 18,
                                                        objectFit: "contain",
                                                        fallbackSrc: (0,ImageUtils/* getLinkProxyFile */.GD)(label === null || label === void 0 ? void 0 : label.preIconSvg),
                                                        src: (0,ImageUtils/* getLinkProxyFile */.GD)(label === null || label === void 0 ? void 0 : label.preIconSvg),
                                                        alt: "img"
                                                    })
                                                }, label === null || label === void 0 ? void 0 : label.code)
                                            }, label === null || label === void 0 ? void 0 : label.code);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: product.name
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardNewList_styles_module_default()).countPerItem,
                                children: product.volume || ""
                            })
                        ]
                    }),
                    medicineTypeLabels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardNewList_styles_module_default()).medicineType,
                        children: medicineTypeLabels.map(function(info) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                src: info.icon.src,
                                width: info.icon.width,
                                height: info.icon.height,
                                objectFit: "contain",
                                alt: info.label
                            }, info.variant);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardNewList_styles_module_default()) === null || (ProductCardNewList_styles_module_default()) === void 0 ? void 0 : (ProductCardNewList_styles_module_default()).sellerContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SellerInfo, {
                            sellerInfo: product.sellerInfo,
                            tags: product === null || product === void 0 ? void 0 : product.tags,
                            isProductCard: true,
                            product: product
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardNewList_styles_module_default()).progressContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardNewList_styles_module_default()).progressBuy,
                                children: product.productType !== "NORMAL" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLinearProgress/* default */.Z, {
                                            value: percentLine || percentLineDeal || 5,
                                            variant: "determinate",
                                            width: "100%",
                                            height: "14px !important",
                                            bgcolor: "#F9BDC0",
                                            bgliner: "#EA202B",
                                            linerradius: 0
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProductCardNewList_styles_module_default()).buyCount,
                                            children: percentLineDeal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (0,helper/* conditionRender */.Yl)(percentLineDeal) ? (0,helper/* checkRule */.Tq)(percentLineDeal) : "Đ\xe3 b\xe1n ".concat(totalSold)
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (0,helper/* conditionRender */.Yl)(percentLine) ? (0,helper/* checkRule */.Tq)(percentLine) : "Đ\xe3 b\xe1n ".concat(totalSold)
                                            })
                                        })
                                    ]
                                }) : null
                            }),
                            !hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLimitMessage/* default */.Z, {
                                consumedMaxQuantity: product.consumedMaxQuantity,
                                unit: product.unit,
                                page: "products",
                                className: (ProductCardNewList_styles_module_default()).limitMessage,
                                isNewCard: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardNewList_styles_module_default()).controlQuantity,
                        children: ((ref14 = product.skuReplace) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplaceProductBlock, {
                            slug: (ref15 = product.skuReplace) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.sku) === null || ref17 === void 0 ? void 0 : ref17.slug,
                            hasErrorMessage: hasError,
                            errorMessage: errorMessageProduct || product.errorMessage || "Đang cập nhật gi\xe1",
                            skuReplace: product.skuReplace
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardNewList_styles_module_default()).error,
                                children: errorMessageProduct || product.errorMessage || "Đang cập nhật gi\xe1"
                            })
                        })
                    })
                ]
            }),
            !hasError && renderQuantityInput()
        ]
    });
};
var ReplaceProductBlock = function(param) {
    var _hasErrorMessage = param.hasErrorMessage, hasErrorMessage = _hasErrorMessage === void 0 ? false : _hasErrorMessage, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, _skuReplace = param.skuReplace, skuReplace = _skuReplace === void 0 ? [] : _skuReplace;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isOnEffect = ref[0], toggleEffect = ref[1];
    var handleClick = function() {
        var listSkuReplaceBlock;
        if (router.pathname === Paths/* SUBSTITUTES */.mv) {
            listSkuReplaceBlock = skuReplace.map(function(item) {
                var ref;
                return item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.sku;
            });
        } else {
            listSkuReplaceBlock = skuReplace.map(function(item) {
                return item === null || item === void 0 ? void 0 : item.sku;
            });
        }
        var queryAllSkuReplaceBlock = listSkuReplaceBlock === null || listSkuReplaceBlock === void 0 ? void 0 : listSkuReplaceBlock.map(function(item) {
            return document.getElementById(item);
        });
        if ((queryAllSkuReplaceBlock === null || queryAllSkuReplaceBlock === void 0 ? void 0 : queryAllSkuReplaceBlock.length) > 0) {
            queryAllSkuReplaceBlock === null || queryAllSkuReplaceBlock === void 0 ? void 0 : queryAllSkuReplaceBlock.forEach(function(item) {
                item === null || item === void 0 ? void 0 : item.classList.add((ProductCardNewList_styles_module_default()).glowOnEffect);
                toggleEffect(true);
                setTimeout(function() {
                    item === null || item === void 0 ? void 0 : item.classList.remove((ProductCardNewList_styles_module_default()).glowOnEffect);
                    toggleEffect(false);
                }, 3000);
            });
        }
    };
    if (!hasErrorMessage) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        padding: "0 8px",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (ProductCardNewList_styles_module_default()).skuReplaceErrorMessage,
                children: errorMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                className: (ProductCardNewList_styles_module_default()).buttonRedirectReplaceSku,
                onClick: function() {
                    if (!isOnEffect) {
                        handleClick();
                    }
                },
                children: [
                    "Xem sản phẩm thay thế",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Images/* SUBSTITUDE_ARROW_RIGHT_ICON */.NWx,
                        width: 16,
                        height: 16,
                        alt: "arrow right icon"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 60547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_QuantityControlTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components-v2/ui/ConsultSpecialProductBtn/index.js + 4 modules
var ConsultSpecialProductBtn = __webpack_require__(40420);
// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/index.js
var RemoveProductModal = __webpack_require__(64325);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/context/Cart/CartContext.js + 2 modules
var CartContext = __webpack_require__(15012);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/zustand-lib/InterfaceZustand.ts
var InterfaceZustand = __webpack_require__(4535);
// EXTERNAL MODULE: ./src/zustand-lib/useCart.ts
var useCart = __webpack_require__(68140);
;// CONCATENATED MODULE: ./src/hooks/useCartControlTable.js






var REGEX_NUMBER = new RegExp("^[0-9]+$");
function useCartControlTable(product, inputRef) {
    var ref = (0,react.useState)(0), currentValue = ref[0], setCurrentValue = ref[1];
    var ref1 = (0,react.useState)(0), valueChange = ref1[0], setValueChange = ref1[1];
    var ref2 = (0,react.useState)(false), isShowModalRemove = ref2[0], setIsShowModalRemove = ref2[1];
    var ref3 = (0,useCart/* default */.ZP)(), cartData = ref3.cartData, lastUpdatedIDRef = ref3.lastUpdatedIDRef;
    var cartItems = (0,CartContext/* useCart */.jD)().cartItems;
    var ref4 = (0,useCart/* useCartActions */.gV)(), updateCartItem = ref4.updateCartItem, removeCartItem = ref4.removeCartItem, getIDRef = ref4.getIDRef, getSKUfromIDRef = ref4.getSKUfromIDRef;
    var ref5 = (0,react.useRef)(getIDRef(product)), idRef = ref5.current;
    // Ensure that the input value is always in sync with the cartData
    // Use case: When there are many cards of the same product in the same page, and the user changes the quantity of one card, the quantity of the other cards should also be updated
    (0,react.useEffect)(function syncQuantity() {
        if (idRef === lastUpdatedIDRef) return; // Don't update itself
        if (getSKUfromIDRef(idRef) !== product.sku) return; // Don't update if this is not its product
        var quantityInCart = product.quantity || 0;
        if ((cartData || []).length > 0) {
            var productInCart = cartData.map(function(group) {
                return group.products;
            }).flat().find(function(p) {
                return p.skuCode === product.sku;
            });
            quantityInCart = (productInCart === null || productInCart === void 0 ? void 0 : productInCart.quantityInCart) || 0;
        } else if ((cartItems || []).length > 0) {
            var productInCart1 = cartItems.find(function(p) {
                return p.sku === product.sku;
            });
            quantityInCart = (productInCart1 === null || productInCart1 === void 0 ? void 0 : productInCart1.quantity) || 0;
        }
        // HACK: use setTimeout to change the input value in the next tick
        setTimeout(function() {
            if (inputRef.current && +inputRef.current.value !== quantityInCart) {
                inputRef.current.value = String(quantityInCart);
                setCurrentValue(quantityInCart);
            }
        }, 0);
    }, [
        cartData,
        cartItems
    ]);
    var productQuantity = product.quantity || 0;
    var handleCart = function(val, type) {
        var params = {
            idRef: idRef,
            newQuantity: +val,
            product: (0,_object_spread/* default */.Z)({
                sku: product.sku,
                type: product.type,
                name: product.name,
                productId: product.productId,
                sellerCode: product.sellerCode,
                blockCode: product === null || product === void 0 ? void 0 : product.blockCode,
                metadata: (0,_object_spread/* default */.Z)({}, product === null || product === void 0 ? void 0 : product.trackingMetadata),
                // sellerID: product.sellerId,
                // eventSource: product.eventSource,
                // recommendSKUs: product.recommendSKUs,
                // metric: product.metric,
                isDeal: false,
                price: product.displayPrice
            }, type === InterfaceZustand/* UPDATE_CART.REMOVE */.g.REMOVE && {
                slug: product.slug,
                salePrice: "",
                cartItemType: ""
            })
        };
        switch(type){
            case InterfaceZustand/* UPDATE_CART.INCREASE */.g.INCREASE:
                return updateCartItem((0,_object_spread/* default */.Z)({
                    type: InterfaceZustand/* UPDATE_CART.INCREASE */.g.INCREASE
                }, params));
            case InterfaceZustand/* UPDATE_CART.DECREASE */.g.DECREASE:
                return updateCartItem((0,_object_spread/* default */.Z)({
                    type: InterfaceZustand/* UPDATE_CART.DECREASE */.g.DECREASE
                }, params));
            case InterfaceZustand/* UPDATE_CART.REMOVE */.g.REMOVE:
                return removeCartItem((0,_object_spread/* default */.Z)({
                    type: InterfaceZustand/* UPDATE_CART.REMOVE */.g.REMOVE
                }, params));
        }
    };
    var handler = (0,react.useCallback)((0,debounce/* default */.ZP)(function(val, updateType) {
        return handleCart(val, updateType);
    }, 400), [
        product
    ]);
    var confirmRemove = function() {
        inputRef.current.value = 0;
        setValueChange(0);
        setIsShowModalRemove(false);
        return handler(0, InterfaceZustand/* UPDATE_CART.REMOVE */.g.REMOVE);
    };
    var closeModal = function() {
        inputRef.current.value = 1;
        setValueChange(1);
        handler(1, InterfaceZustand/* UPDATE_CART.DECREASE */.g.DECREASE);
        setIsShowModalRemove(false);
    };
    var handleDecrease = function(e) {
        e.stopPropagation();
        var newValue = inputRef.current.value - 1;
        if (newValue >= 0) {
            if (newValue === 0) {
                return setIsShowModalRemove(true);
            }
            inputRef.current.value = newValue;
            setValueChange(newValue);
            return handler(newValue, InterfaceZustand/* UPDATE_CART.DECREASE */.g.DECREASE);
        }
        return null;
    };
    var handleIncrease = function(e) {
        var ref;
        e.stopPropagation();
        var newValue = +inputRef.current.value + 1;
        if (newValue > (product === null || product === void 0 ? void 0 : (ref = product.consumedMaxQuantity) === null || ref === void 0 ? void 0 : ref.maxQuantityConsumed)) return null;
        setValueChange(newValue);
        inputRef.current.value = newValue;
        return handler(newValue, InterfaceZustand/* UPDATE_CART.INCREASE */.g.INCREASE);
    };
    var handleBlurInput = function(e) {
        var value = e.target.value;
        if (+value !== +currentValue) {
            if (+value && REGEX_NUMBER.test(value)) {
                return handler(value, +value > +currentValue ? InterfaceZustand/* UPDATE_CART.INCREASE */.g.INCREASE : InterfaceZustand/* UPDATE_CART.DECREASE */.g.DECREASE);
            }
        }
        if (+value === 0 && +value !== valueChange) {
            return setIsShowModalRemove(true);
        }
        return null;
    };
    var handleChangeInput = function(e) {
        var value = e.target.value;
        if (value === "00") {
            inputRef.current.value = 0;
            return;
        }
        if (value && inputRef.current.value !== "0") {
            var ref;
            if (+value > +(product === null || product === void 0 ? void 0 : (ref = product.consumedMaxQuantity) === null || ref === void 0 ? void 0 : ref.maxQuantityConsumed) || +value > 10000) {
                var ref1;
                var valueData = +(product === null || product === void 0 ? void 0 : (ref1 = product.consumedMaxQuantity) === null || ref1 === void 0 ? void 0 : ref1.maxQuantityConsumed) || 10000;
                inputRef.current.value = valueData;
                setValueChange(valueData);
            } else if (REGEX_NUMBER.test(+value)) {
                inputRef.current.value = parseInt(value, 10);
                setValueChange(parseInt(value, 10));
            } else {
                inputRef.current.value = 0;
                setValueChange(0);
            }
        } else {
            inputRef.current.value = 0;
        }
    };
    (0,react.useEffect)(function() {
        setCurrentValue(productQuantity);
        setValueChange(productQuantity);
        if (inputRef.current) {
            inputRef.current.value = productQuantity;
        }
    }, []);
    return [
        handleIncrease,
        handleBlurInput,
        handleChangeInput,
        handleDecrease,
        confirmRemove,
        closeModal,
        isShowModalRemove,
        valueChange
    ];
};

// EXTERNAL MODULE: ./src/hooks/useProductConsultation.js
var useProductConsultation = __webpack_require__(48699);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlTable/styles.module.css
var styles_module = __webpack_require__(10458);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/QuantityControlTable/index.js










var CartIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).inputVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z",
                    fill: "#999999"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z",
                    fill: "#999999"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z",
                    fill: "#999999"
                })
            ]
        })
    });
};
var NewIconMinus = function(param) {
    var handleDecrease = param.handleDecrease, currentValue = param.currentValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleDecrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).minusContainerNew, "qty-control-table-minus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "28",
            height: "28",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12H17",
                stroke: currentValue === 0 ? "#999999" : "#005c29",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        })
    });
};
var IconMinus = function(param) {
    var handleDecrease = param.handleDecrease;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleDecrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).minusContainer, "qty-control-table-minus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).minus
        })
    });
};
var NewIconAdd = function(param) {
    var handleIncrease = param.handleIncrease, currentValue = param.currentValue, maxQuantityConsumed = param.maxQuantityConsumed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIncrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).addContainerNew, "qty-control-table-plus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "28",
            height: "28",
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 17V7",
                    stroke: currentValue >= maxQuantityConsumed ? "#999999" : "#005c29",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7 12L17 12",
                    stroke: currentValue >= maxQuantityConsumed ? "#999999" : "#005c29",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        })
    });
};
var IconAdd = function(param) {
    var handleIncrease = param.handleIncrease, currentValue = param.currentValue, maxQuantityConsumed = param.maxQuantityConsumed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIncrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).addContainer, currentValue >= maxQuantityConsumed && (styles_module_default()).disabled, "qty-control-table-plus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).addIcon
        })
    });
};
/**
 * @param {Object} props
 * @param {Object} props.product
 * @param {string} [props.className]
 * @param {boolean} [props.isBuy]
 * @param {boolean} [props.newCard]
 * @param {(e: any) => void} [props.onMinus]
 * @param {(e: any) => void} [props.onChange]
 * @param {(e: any) => void} [props.onAdd]
 * @param {string} [props.consultVariant] biến thể nút "Tư vấn sản phẩm" (VARIANT_LIST)
 */ var QuantityControlTable = function(param) {
    var product = param.product, _className = param.className, className = _className === void 0 ? "" : _className, _isBuy = param.isBuy, isBuy = _isBuy === void 0 ? false : _isBuy, _newCard = param.newCard, newCard = _newCard === void 0 ? false : _newCard, onMinus = param.onMinus, onChange = param.onChange, onAdd = param.onAdd, _consultVariant = param.consultVariant, consultVariant = _consultVariant === void 0 ? ConsultSpecialProductBtn/* VARIANT_LIST.LIST */.C.LIST : _consultVariant;
    var ref, ref1;
    var refValue = (0,react.useRef)(null);
    var ref2 = product || {}, _isHighProfit = ref2.isHighProfit, isHighProfit = _isHighProfit === void 0 ? false : _isHighProfit;
    var shouldShowConsultButton = (0,useProductConsultation/* useProductConsultation */.O)().shouldShowConsultButton;
    var ref3 = (0,_sliced_to_array/* default */.Z)(useCartControlTable(product, refValue), 8), handleIncrease = ref3[0], handleBlurInput = ref3[1], handleChangeInput = ref3[2], handleDecrease = ref3[3], confirmRemove = ref3[4], closeModal = ref3[5], isShowModalRemove = ref3[6], currentValue = ref3[7];
    var handleCancel = function(e) {
        e.stopPropagation();
        closeModal();
    };
    var handleRemove = function() {
        confirmRemove();
    };
    if (shouldShowConsultButton(product)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultSpecialProductBtn/* default */.Z, {
            className: "qty-control-table-consult-btn",
            product: product,
            variant: consultVariant
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)((styles_module_default()).maxWidth, isHighProfit ? "highProfitInputQuantity" : null),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((styles_module_default()).container, isBuy && (styles_module_default()).isBuy, className && className, "qty-control-table-wrapper"),
            children: [
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIconMinus, {
                    currentValue: currentValue,
                    handleDecrease: function(e) {
                        handleDecrease(e);
                        onMinus === null || onMinus === void 0 ? void 0 : onMinus(e);
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMinus, {
                    handleDecrease: function(e) {
                        handleDecrease(e);
                        onMinus === null || onMinus === void 0 ? void 0 : onMinus(e);
                    }
                }),
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)((styles_module_default()).groupInput, "qty-control-table-input-group"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).cartIconContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).currentValue,
                                    children: currentValue
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            className: (0,clsx/* default */.Z)((styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).newCardInput, "qty-control-table-input"),
                            inputRef: refValue,
                            onBlur: handleBlurInput,
                            onChange: function(e) {
                                handleChangeInput(e);
                                onChange === null || onChange === void 0 ? void 0 : onChange(e);
                            },
                            type: "number",
                            disableUnderline: true
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    className: "qty-control-table-input",
                    inputRef: refValue,
                    onBlur: handleBlurInput,
                    onChange: function(e) {
                        onChange === null || onChange === void 0 ? void 0 : onChange(e);
                        handleChangeInput(e);
                    },
                    type: "number",
                    disableUnderline: true
                }),
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIconAdd, {
                    handleIncrease: function(e) {
                        handleIncrease(e);
                        onAdd === null || onAdd === void 0 ? void 0 : onAdd(e);
                    },
                    currentValue: currentValue,
                    maxQuantityConsumed: product === null || product === void 0 ? void 0 : (ref = product.consumedMaxQuantity) === null || ref === void 0 ? void 0 : ref.maxQuantityConsumed
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAdd, {
                    handleIncrease: function(e) {
                        handleIncrease(e);
                        onAdd === null || onAdd === void 0 ? void 0 : onAdd(e);
                    },
                    currentValue: currentValue,
                    maxQuantityConsumed: product === null || product === void 0 ? void 0 : (ref1 = product.consumedMaxQuantity) === null || ref1 === void 0 ? void 0 : ref1.maxQuantityConsumed
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                    product: product,
                    visible: isShowModalRemove,
                    onClose: handleCancel,
                    onRemove: handleRemove
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_QuantityControlTable = (QuantityControlTable);


/***/ }),

/***/ 68556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductLimitMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19238);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90512);
/* harmony import */ var utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44097);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93803);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);






function ProductLimitMessage(param) {
    var _consumedMaxQuantity = param.consumedMaxQuantity, consumedMaxQuantity = _consumedMaxQuantity === void 0 ? {} : _consumedMaxQuantity, page = param.page, _row = param.row, row = _row === void 0 ? false : _row, _skuStatus = param.skuStatus, skuStatus = _skuStatus === void 0 ? "" : _skuStatus, _isSkuAvailable = param.isSkuAvailable, isSkuAvailable = _isSkuAvailable === void 0 ? false : _isSkuAvailable, _isSkuActive = param.isSkuActive, isSkuActive = _isSkuActive === void 0 ? false : _isSkuActive, _isGift = param.isGift, isGift = _isGift === void 0 ? false : _isGift, _className = param.className, className = _className === void 0 ? "" : _className, _isNewCard = param.isNewCard, isNewCard = _isNewCard === void 0 ? false : _isNewCard, _requiredCertificates = param.requiredCertificates, requiredCertificates = _requiredCertificates === void 0 ? "" : _requiredCertificates;
    var render = function render() {
        if (isGift) {
            return null;
        }
        if (!isSkuActive) {
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: "Sản phẩm đ\xe3 ngưng b\xe1n"
                    })
                });
            }
        }
        if (!isSkuAvailable) {
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: "Sản phẩm chưa hỗ trợ giao v\xf9ng n\xe0y"
                    })
                });
            }
        }
        if (skuStatus === "OUT_OF_STOCK") {
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: "Sản phẩm tạm hết h\xe0ng"
                    })
                });
            }
        }
        if (skuStatus === "SUSPENDED") {
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: "Sản phẩm đ\xe3 ngưng b\xe1n"
                    })
                });
            }
        }
        if (skuStatus === "STOP_PRODUCING") {
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: "Sản phẩm ngưng sản xuất"
                    })
                });
            }
        }
        if (requiredCertificates === "REQUIRED_CERTIFICATE") {
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: "Bạn chưa đủ giấy ph\xe9p để mua sản phẩm n\xe0y"
                    })
                });
            }
        }
        if ((consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed) > 0 && (consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed) < 10000) {
            if (page === "products" && isNewCard) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default()) === null || (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default()) === void 0 ? void 0 : (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().textNewCard),
                    children: [
                        "Đặt tối đa ",
                        (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed),
                        " sản phẩm"
                    ]
                });
            }
            if (page === "products") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: row ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc) : (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger_column), (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc)),
                    children: [
                        "Đặt tối đa ",
                        (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed),
                        " sản phẩm"
                    ]
                });
            }
            if (page === "product") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_limit),
                    children: [
                        "Đặt tối đa ",
                        (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed),
                        " sản phẩm"
                    ]
                });
            }
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: [
                            "Đặt tối đa ",
                            (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed),
                            " sản phẩm"
                        ]
                    })
                });
            }
            if (page === "quick-order") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    color: "textSecondary",
                    className: row ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger) : (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger_column_quickOrder), (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc_quick_order)),
                    children: [
                        "Đặt tối đa ",
                        (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed),
                        " sản phẩm"
                    ]
                });
            }
        }
        if ((consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed) === 0 && (consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityType) === "PER_DAY") {
            if (page === "products" && isNewCard) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: row ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc) : (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(className && className),
                    children: "Đ\xe3 mua hết số lượng h\xf4m nay"
                });
            }
            if (page === "products") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: row ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc) : (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger_column), (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc)),
                    children: "Đ\xe3 mua hết số lượng h\xf4m nay"
                });
            }
            if (page === "product") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger),
                    children: [
                        "Bạn đ\xe3 mua hết ",
                        (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityPerDay),
                        " sản phẩm h\xf4m nay. Vui l\xf2ng quay lại v\xe0o ng\xe0y mai."
                    ]
                });
            }
            if (page === "cart") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().boxPerDay),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().product_category)),
                        color: "error",
                        variant: "body2",
                        component: "p",
                        children: [
                            "Bạn đ\xe3 mua hết ",
                            (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityPerDay),
                            " sản phẩm h\xf4m nay. Vui l\xf2ng quay lại v\xe0o ng\xe0y mai."
                        ]
                    })
                });
            }
            if (page === "quick-order") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    color: "textSecondary",
                    className: row ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger) : (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_danger_column_quickOrder), (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_desc_quick_order)),
                    children: [
                        "Bạn đ\xe3 mua hết ",
                        (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityPerDay),
                        " sản phẩm h\xf4m nay. Vui l\xf2ng quay lại v\xe0o ng\xe0y mai."
                    ]
                });
            }
        }
        return null;
    };
    return render();
};


/***/ }),

/***/ 80966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ruVTs","promo":"styles_promo__cmbDd","store":"styles_store__rwR8f","storeVip":"styles_storeVip__E6mJ7","contract":"styles_contract__X4DFE","nearExpiration":"styles_nearExpiration__MruDA","titleBadbes":"styles_titleBadbes__nseDB","badges_success":"styles_badges_success__tetM2","badges_warning":"styles_badges_warning__U0J58","image":"styles_image__cDA8v","titleContainer":"styles_titleContainer__r12bK","titleWrapper":"styles_titleWrapper__WUGzM","titleProduct":"styles_titleProduct__CF8WX","customButton":"styles_customButton__O2Iqn","tooltipRight":"styles_tooltipRight__1KG4L","icon":"styles_icon__c7pTl","listTag":"styles_listTag__EiLNe","pointInfo":"styles_pointInfo__vrhUn","multiple":"styles_multiple__RrHLw","score":"styles_score__PHarZ","infoScore":"styles_infoScore__ZYGv_","priceContainer":"styles_priceContainer___mV9c","cardChip":"styles_cardChip__wgasQ","MuiTypography-root":"styles_MuiTypography-root__cBeWb","price":"styles_price__o70iu","pricePromo":"styles_pricePromo__LmPKF","progressContainer":"styles_progressContainer__liK0t","countPerItem":"styles_countPerItem__L9adv","priceAuth":"styles_priceAuth__bLNwv","progressBuy":"styles_progressBuy__9mcyD","buyCount":"styles_buyCount__nlB_U","dateExpired":"styles_dateExpired__I7Vzl","bottom":"styles_bottom__r_bfs","bottomMobile":"styles_bottomMobile__ENJQa","customLink":"styles_customLink__kUgXe","anotherSeller":"styles_anotherSeller__kTnk2","count":"styles_count__PtfMY","redirect":"styles_redirect__fY_p5","giftPromo":"styles_giftPromo__qKRl1","titleMaxQuantity":"styles_titleMaxQuantity__5jQRp","underContainer":"styles_underContainer__BS5Q8","topContainer":"styles_topContainer__J_x_w","stylesImage":"styles_stylesImage__0Cmje","error":"styles_error__r7_aR","quantityControlContainer":"styles_quantityControlContainer__DuU0W","tagContainer":"styles_tagContainer__mHpj0","labelImage":"styles_labelImage__MkPX6","hangDiemLabelImage":"styles_hangDiemLabelImage__L4_QD","listTagGuide":"styles_listTagGuide__6BQQp","footerGuide":"styles_footerGuide__Y7VBF","limitMessage":"styles_limitMessage__zpJbh","controlQuantity":"styles_controlQuantity__ixJtt","sellerContainer":"styles_sellerContainer__kIjYl","skuReplaceErrorMessage":"styles_skuReplaceErrorMessage__73ht_","buttonRedirectReplaceSku":"styles_buttonRedirectReplaceSku__Jcs1D","replaceSkuTag":"styles_replaceSkuTag__o1o_O","glowOnEffect":"styles_glowOnEffect__cOU5K","glowing":"styles_glowing__ugOyu","medicineType":"styles_medicineType__63V2J"};

/***/ }),

/***/ 29767:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gpq4v","minusContainer":"styles_minusContainer__RUpXx","minus":"styles_minus__wYXC3","addContainerNew":"styles_addContainerNew__c2IIk","minusContainerNew":"styles_minusContainerNew__2Uzuo","count":"styles_count__bKxY8","addContainer":"styles_addContainer__NGyIa","addIcon":"styles_addIcon__eIcW1","disabled":"styles_disabled__Q5fAA","newCardInput":"styles_newCardInput__p2VDj","maxWidth":"styles_maxWidth__WsSNH","groupInput":"styles_groupInput__QYDWv","cartIconContainer":"styles_cartIconContainer__TsjAx","inputVisible":"styles_inputVisible__9_at5","currentValue":"styles_currentValue__JlFyb"};

/***/ }),

/***/ 10458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WvT_A","minusContainer":"styles_minusContainer__D6Bac","minus":"styles_minus__0cccB","addContainerNew":"styles_addContainerNew__tcgCs","minusContainerNew":"styles_minusContainerNew__I7nr4","count":"styles_count__3g0gE","addContainer":"styles_addContainer__cj8gz","addIcon":"styles_addIcon__Wd3rJ","disabled":"styles_disabled__4crXC","newCardInput":"styles_newCardInput___UrzW","maxWidth":"styles_maxWidth__xPPV6","groupInput":"styles_groupInput__206O1","cartIconContainer":"styles_cartIconContainer__JTOM_","inputVisible":"styles_inputVisible__q5OCD","currentValue":"styles_currentValue__XqIgi"};

/***/ }),

/***/ 93803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_category":"styles_product_category__YMvRB","boxPerDay":"styles_boxPerDay__7xB_4","text_desc":"styles_text_desc__25WL3","text_danger_column":"styles_text_danger_column__xXUn_","text_limit":"styles_text_limit__z1qJ0","text_danger":"styles_text_danger__c0OMr","text_danger_mv2":"styles_text_danger_mv2__eGzqa","text_danger_column_quickOrder":"styles_text_danger_column_quickOrder__XgHkl","text_danger_column_quickOrder_bottom":"styles_text_danger_column_quickOrder_bottom__dPUCM","text_desc_quick_order":"styles_text_desc_quick_order__7sOWy","textNewCard":"styles_textNewCard__dwq3I"};

/***/ }),

/***/ 72303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"supplierTitle":"styles_supplierTitle__EiwjU","supplier_wishlist":"styles_supplier_wishlist__TZ0wr","name":"styles_name__IHYLk","supplierName":"styles_supplierName__AxHU6","link":"styles_link__T_OV2","link_v2":"styles_link_v2__De3Su","image_logo":"styles_image_logo__LIfop","supplierTitle_mv2":"styles_supplierTitle_mv2__qG9tD","link_mv2":"styles_link_mv2__v5Bi2","supplier_title_v2":"styles_supplier_title_v2__lm35d","text_tf_none":"styles_text_tf_none__5GpaE","m0":"styles_m0__7Jqd_","sellerProduct":"styles_sellerProduct__K25aq"};

/***/ })

}]);